import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  StyledLine,
  StyledLineInside,
  // CardHolder,
  Title,
  ListElement,
  // AuthorAndTime,
  Rating,
  FlexContainer,
  Image
} from '../StyledComponents';
import { rootConfig } from '../../../config/config';
import {
  SideBarCardData
  // SideBarCard
} from '../StyledComponents/StyledSideBar';

const List_Vertical = props => {
  // console.log('props: ', props);
  const { title, listItems } = props;

  let cardItems = listItems.map(listItem => (
    <FlexContainer
      className="pointer"
      direction="column"
      style={{ width: '18.75rem', margin: '10px 10px 10px 10px' }}
      key={listItem.id}
      onClick={() => navigate(listItem.postSlug)}
    >
      <div className="ImageDiv relative">
        {listItem.rating ? (
          <FlexContainer className="Rating">
            <Rating
              className="absolute right-0"
              width="50px"
              height="50px"
              padding="12px"
              background="#4db2ec"
            >
              <Title
                className="Rating-Text"
                fontFamily="Montserrat"
                fontSize="2.25rem"
                color="#fff"
              >
                {listItem.rating}
              </Title>
            </Rating>
          </FlexContainer>
        ) : null}
        <Image
          src={
            listItem.featuredImage
              ? `${rootConfig.imagesRoot}/${listItem.featuredImage.file}`
              : null
          }
          alt={listItem.postSlug}
        />
      </div>
      <SideBarCardData>
        <Title fontFamily="Nunito" fontSize="1.2rem" fontWeight="bold">
          {listItem.postTitle}
        </Title>
        {/* <AuthorAndTime
          color="#757575"
          fontFamily="Montserrat"
          fontSize="0.75rem"
          fontWeight="normal"
        >
          <div>{listItem.postAuthor.authorName}</div>
          <div>{listItem.postDate}</div>
        </AuthorAndTime> */}
      </SideBarCardData>
    </FlexContainer>
  ));

  const navigate = postSlug => {
    postSlug = postSlug.toLowerCase();
    // console.log('postSlug: ', postSlug);
    props.history.push(`/${postSlug}`);
  };

  return (
    <div className={props.className}>
      <ListElement className="w-100" maxwidth="1040px" padding="1rem 1.2rem">
        <Title
          // onClick={() =>
          //   navigate(`${props.history.location.pathname.slice(1)}/${title}`)
          // }
          fontFamily="Montserrat"
          fontSize="1.25rem"
          fontWeight="bold"
          letterSpacing="0.6"
        >
          {title}
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine>
        <FlexContainer className="justify-center">{cardItems}</FlexContainer>
      </ListElement>
    </div>
  );
};

export default withRouter(List_Vertical);
